import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const Chapter = RepositoryFactory.get("chapter");
export default {
  CreateChapter({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Chapter.CreateChapter(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  GetChapterByCourseId({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Chapter.GetChapterByCourseId(payload);
        commit("GET_Chapter_DATA", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleChapter({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Chapter.getSingleChapter(payload);

        commit("GET_SINGLE_Chapter", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateChapter({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload, "jgjyvujvy");
        const { data } = await Chapter.updateChapter(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteChapter({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload, "acctionnn");
        const { data } = await Chapter.deleteChapter(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
